import { Icons } from '@/components/Shares/Icons';
import { useNavbarItems } from '@/hooks/useNavbarItems';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Flex, Group, Stack, Text, rem } from '@mantine/core';
import { NavbarItemMobile } from './NavbarItemMobile';
export type NavbarMenuMobileProps = {
  handleMainClick: (path: string) => void;
};
export const NavbarMenuMobile: React.FC<NavbarMenuMobileProps> = ({
  handleMainClick
}) => {
  const {
    values: mainItems
  } = useNavbarItems();
  const {
    setOpenModal
  } = useModalAction();
  const {
    i18n
  } = useLingui();
  return <Group gap={30} wrap="nowrap" pos="relative">
      <Stack justify="center" align="center" gap={5} component="a">
        <Icons className="icon-pr-line-browse" color="var(--icon-color)" fontSize={30} />
        <Text fz={10} fw={700} tt="uppercase" c="var(--text-dark)">
          {i18n._('Browse')}
        </Text>
      </Stack>
      <Flex gap={30}>
        {mainItems.map((item, index) => <NavbarItemMobile key={item.label} index={index} {...item} handleItemClick={handleMainClick} iconSize={30} />)}
      </Flex>

      <Stack justify="center" align="center" gap={5} onClick={() => setOpenModal(MODAL.CHAT)}>
        <Icons className="icon-pr-flat-chat-bubble" color="var(--icon-color)" fontSize={30} />
        <Text fz={10} fw={700} tt="uppercase" c="var(--text-dark)">
          {i18n._('Chat')}
        </Text>
      </Stack>
    </Group>;
};